import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  textError: {
    color: theme.palette.error.main,
  },
}))

export default styles
